import { APP_CONSTANTS } from "components/constants/AppConstants";
import { useAppDispatch } from "hooks/reduxHooks";
import { useEffect } from "react";
import { doLogout } from "store/slices/auth.slice";

const LogoutOnUpdate = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const storedVersion = localStorage.getItem("app_version");

    if (storedVersion !== APP_CONSTANTS.APP_VERSION) {
      //   localStorage.removeItem("token"); // Logout user
      localStorage.setItem("app_version", APP_CONSTANTS.APP_VERSION);
      //window.location.reload(); // Reload to apply changes
      dispatch(doLogout());
      const win: Window = window;
      win.location = "/auth/login";
    }
  }, []);

  return null; // No UI needed
};

export default LogoutOnUpdate;
